import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Typography, TextField, Button, Grid, Box, Paper } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

const ForgotPassword = () => {
  const [formData, setFormData] = useState({
    emailOrPhone: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateForm = () => {
    let newErrors = {};
    if (!formData.emailOrPhone)
      newErrors.emailOrPhone = "Email or phone is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await axios.post(
        `${apiUrl}/auth/forgot-password`,
        formData
      );
      navigate("/reset-password"); // Redirect to reset password page or any other page you prefer
    } catch (error) {
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Box
      sx={{
        bgcolor: "#B3C8CF",
        minHeight: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          maxWidth: "600px",
          padding: "20px",
          borderRadius: "10px",
          bgcolor: "#B3C8CF",
          border: "1px solid black",
        }}
      >
        <Typography variant="h5" component="h5" align="center" gutterBottom>
          Forgot Password
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Email or Phone */}
            <Grid item xs={12}>
              <TextField
                label="Email or Phone"
                size="small"
                value={formData.emailOrPhone}
                onChange={handleChange}
                name="emailOrPhone"
                fullWidth
                error={!!errors.emailOrPhone}
                helperText={errors.emailOrPhone}
              />
            </Grid>

            {/* Submit Button */}
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                type="submit"
                variant="contained"
                size="large"
                sx={{ bgcolor: "black", textAlign: "center" }}
                color="primary"
              >
                Submit
              </Button>
            </Grid>

            {/* Sign In Link */}
            <Grid item xs={12}>
              <Typography variant="body2" align="center" sx={{ mt: 2 }}>
                Remembered your password?{" "}
                <RouterLink
                  to="/sign-in"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  Sign In
                </RouterLink>
              </Typography>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
